import { observable, computed} from 'mobx';
import Silos from '../objects/silos';
import Hopper from "../objects/hopper";

export default class StorageStore {

    @observable silosList = [
        new Silos(0,5000,'keke'),
        new Silos(1,5000,'keke'),
        new Silos(2,5000,'keke'),
        new Silos(3,5000,'keke'),
        new Silos(4,5000,'keke'),
        new Silos(5,5000,'keke'),
        // new Silos(5000,'keke',"wheat",1000,13,13),
        // new Silos(5000,'keke',"soy",1000,13,13),
        // new Silos(5000,'keke',"wheat",1000,13,13),
        // new Silos(5000,'keke',"wheat",1000,13,13),
        // new Silos(5000,'keke',"wheat",1000,13,13),
        // new Silos(5000,'keke',"soy",1000,13,13),
        // new Silos(3750),
        // new Silos(3750),
        // new Silos(2500),
        // new Silos(5000,'keke',"wheat",1000,13,13),
        // new Silos(2500,'corn',2000,5,5,"decreased")
    ];


    @observable hoppersList = [
        new Hopper(0,400,"Hopper"),
        new Hopper(1,400,"Hopper"),
        // new Hopper(400,"Hopper"),
        // new Hopper(400,"Hopper")
    ];

}




// WEBPACK FOOTER //
// ./src/shared/stores/GameSessionStore/StorageStore.js